import { render, staticRenderFns } from "./BS_accountInfo.vue?vue&type=template&id=3beb904a&scoped=true&"
import script from "./BS_accountInfo.vue?vue&type=script&lang=js&"
export * from "./BS_accountInfo.vue?vue&type=script&lang=js&"
import style0 from "./BS_accountInfo.vue?vue&type=style&index=0&id=3beb904a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb904a",
  null
  
)

export default component.exports